import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import {
  getPublicCollectionBySlugV3ResponseSchema,
  type ICollectionV3,
} from './get-public-collection-by-slug-v3-response';

export async function getPublicCollectionBySlugV3Api(slug: string) {
  return getRequest<IAPI<ICollectionV3>>({
    path: `/collections/v3/slug/${encodeURIComponent(slug)}`,
    schema: getPublicCollectionBySlugV3ResponseSchema,
  });
}
